import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { useWindowSize } from "@miro-site/core";
import Desktop from "./components/Desktop";
import Mobile from "./components/Mobile";
var CategoryNav = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var _$ref = useState(false), isMounted = _$ref[0], setMounted = _$ref[1];
    var theme = useTheme();
    var windowSize = useWindowSize();
    var isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small;
    useEffect(function() {
        setMounted(true);
    }, []);
    if (!isMounted) {
        return null;
    }
    if (isMobileViewPort) {
        return /*#__PURE__*/ _jsx(Mobile, _object_spread({
            ref: ref
        }, props));
    }
    return /*#__PURE__*/ _jsx(Desktop, _object_spread({
        ref: ref
    }, props));
});
CategoryNav.displayName = "CategoryNav";
export default CategoryNav;
export { default as Button } from "./components/Button";
